module.exports = __webpack_public_path__ + "img/hand_sideleft_45.702c0884.svg";